module.exports = __webpack_public_path__ + "0006643062e7038d3461488c4887769b.jpg";